import { ObjectRule } from '@/classes/rules/ObjectRule';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { DateRule } from '@/classes/rules/DateRule';
import { EnumRule } from '@/classes/rules/EnumRule';
import { BooleanRule } from '@/classes/rules/BooleanRule';
import { GridConnectionRef } from '@/dto/scenario/ren-fr/capex/CapexReference';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioCapexExt } from '@/classes/scenario/ren-fr/capex/ScenarioCapexExt';

export const buildCapexRules = () => new ObjectRule<ScenarioCapexExt>('capex', [
  new DateRule('spvPurchaseDate').withIsAvailable(() => false),
  new MinMaxRule('spvPurchase'),
  new MinMaxRule('impactStudy'),
  new MinMaxRule('publicInquiry'),
  new MinMaxRule('permitDisplay'),
  new MinMaxRule('technical'),
  new MinMaxRule('businessDeveloper'),
  new MinMaxRule('archaeologicalAssessment'),
  new MinMaxRule('lawyerFees'),
  new MinMaxRule('assetRent'),
  new MinMaxRule('devContractRenFr'),
  new MinMaxRule('devContractExternal'),
  new MinMaxRule('amoContract'),
  new MinMaxRule('others'),
  new MinMaxRule('productible')
    .withIsAvailable(scenario => false),
  new MinMaxRule('authorizations')
    .withIsAvailable(scenario => false),
  new EnumRule('gridConnection', GridConnectionRef),
  new BooleanRule('specializedLink'),
  new MinMaxRule('gridConnectionCost'),
  new MinMaxRule('regionShare'),
  new MinMaxRule('telecom'),
  new MinMaxRule('environmentalMonitoring'),
  new MinMaxRule('ercMeasures'),
  new MinMaxRule('lot0_CspsCt'),
  new MinMaxRule('lot1_PublicWorks'),
  new MinMaxRule('lot2_Foundations'),
  new MinMaxRule('lot3_ElectricalNetwork'),
  new MinMaxRule('lot4_PdlPtr'),
  new MinMaxRule('lot5_WindTurbines'),
  new MinMaxRule('lot6_Supervision'),
  new MinMaxRule('lot7_Ess'),
  new MinMaxRule('lot8_Modules'),
  new MinMaxRule('lot9_Decommissioning'),
  new MinMaxRule('lot10_Transport'),
  new MinMaxRule('misc'),
  new MinMaxRule('uncertainties')
])
  .withIsAvailable(scenario => isRenFranceProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioCapexExt()));

function isRenFranceProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project || scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}

// function isRenFranceWindProject(scenario: ScenarioExt): boolean {
//   return scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project;
// }
